const MODE = process.env.MODE;

let BASE_URL;

switch (MODE) {
  case "local":
  case "LOCAL":
  case "development":
  case "DEVELOPMENT":
    BASE_URL = "https://registration.xyz/";
    break;

  case "production":
  case "PRODUCTION":
    BASE_URL = "https://registration.ican-education.com/";
    break;

  default:
    throw new Error(`Invalid MODE: ${MODE}`);
}

const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const shortenedMonth = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const s3Path = process.env.S3PATH;

export { BASE_URL, month, shortenedMonth, s3Path };
